import styled, { keyframes } from 'styled-components';
import shadowBig from '../../assets/images/speedo_shadow_big.png';
import shadowInactive from '../../assets/images/speedo_shadow_inactive.png';
import shadowSmall from '../../assets/images/speedo_shadow_small.png';

const buttonKeyframes = keyframes`
	0% {
		outline: 0px solid rgba(255, 255, 255, 0.25);
	}
	70% {
		outline: 30px solid rgba(255, 255, 255, 0);
	}
	71% {
		outline: 0px solid rgba(255, 255, 255, 0);
	}
	100% {
		outline: 0px solid rgba(255, 255, 255, 0.25);
	}
`;

const turnSignalKeyframes = keyframes`
	0% {
		opacity: 0;
	}
	50% {
		opacity: 1;
	}
  55% {
    opacity: 0;
  }
	100% {
		opacity: 0;
	}
`;

const StyledContainer = styled.div`
	position: absolute;
	bottom: 0;
	right: 30px;
	user-select: none;
	pointer-events: none;
`;

const SpeedometerContainer = styled.div`
	position: relative;
	z-index: 3;
	width: 240px;
	height: 240px;
`;

const StyledSpeedInfoContainer = styled.div`
	position: absolute;
	top: 34px;
	left: 45px;
	z-index: 3;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 150px;
	height: 240px;
`;

const StyledSpeedText = styled.label`
	position: relative;
	right: 6px;
	color: #fff;
	text-align: center;
	font-family: GT Walsheim Pro;
	font-size: 80px;
	font-weight: 700;
	line-height: normal;
	font-style: italic;
`;

const StyledInfoCarContainer = styled.div`
	position: absolute;
	left: 50%;
	bottom: 20px;
	z-index: 3;
	transform: translateX(-50%);
	display: flex;
	align-items: center;
	column-gap: 20px;
`;

const StyledBackgroundBig = styled.div`
	position: absolute;
	right: -350px;
	bottom: -350px;
	width: 1000px;
	height: 1000px;
	background-image: url(${shadowBig});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;

const StyledBackgroundSmall = styled.div`
	position: absolute;
	top: -155px;
	right: -155px;
	width: 600px;
	height: 600px;
	background-image: url(${shadowSmall});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;

const StyledNotActiveBackground = styled.div`
	position: absolute;
	z-index: 15;
	top: -200px;
	right: -200px;
	width: 640px;
	height: 640px;
	background-image: url(${shadowInactive});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
	opacity: 0;
	transition: opacity 0.3s ease;

	&.background-enter {
		opacity: 0;
	}

	&.background-enter-active,
	&.background-enter-done,
	&.background-exit {
		opacity: 1;
	}

	&.background-exit-active {
		opacity: 0;
	}
`;

const StyledHelpInfoContainer = styled.div`
	position: absolute;
	top: 90px;
	left: 50%;
	z-index: 15;
	transform: translateX(-50%);
	display: flex;
	flex-direction: column;
	align-items: center;
	row-gap: 10px;
	width: 180px;
	opacity: 0;
	transition: opacity 0.3s ease;

	&.helpinfo-enter {
		opacity: 0;
	}

	&.helpinfo-enter-active,
	&.helpinfo-enter-done,
	&.helpinfo-exit {
		opacity: 1;
	}

	&.helpinfo-exit-active {
		opacity: 0;
	}
`;

const StyledEngineButtonBorder = styled.div`
	position: absolute;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	border-radius: 6px;

	animation-name: ${buttonKeyframes};
	animation-duration: 1s;
	animation-timing-function: ease;
	animation-iteration-count: infinite;
`;

const StyledEngineButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	min-width: 20px;
	min-height: 20px;
	border-radius: 6px;
	background-color: #ffffff;
	color: #262628;
	font-family: GT Walsheim Pro;
	font-size: 10px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
`;

const StyledGazContainer = styled.div`
	position: absolute;
	top: -20px;
	left: -36px;
	z-index: 3;
`;

const StyledGazCircle = styled.circle`
	rotate: 150deg;
	transform: translate(-76%, -118%);
	transition: stroke 0.25s ease;
`;

const StyledGazLabels = styled.div`
	position: absolute;
	top: 60px;
	left: -16px;
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	row-gap: 60px;
`;

const StyledStatusIcon = styled.img<{ $active: boolean }>`
	opacity: ${(props) => (props.$active ? 1 : 0.25)};
	transition: opacity 0.25s ease;
`;

const StyledInfoBottomContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 8px;
	margin-top: -8px;
`;

const StyledTurnSignal = styled.img<{ $active: boolean }>`
	opacity: 0;
	animation-name: ${(props) => props.$active && turnSignalKeyframes};
	animation-duration: 1s;
	animation-timing-function: ease;
	animation-iteration-count: infinite;
`;

export {
	SpeedometerContainer,
	StyledBackgroundBig,
	StyledBackgroundSmall,
	StyledContainer,
	StyledEngineButton,
	StyledEngineButtonBorder,
	StyledGazCircle,
	StyledGazContainer,
	StyledGazLabels,
	StyledHelpInfoContainer,
	StyledInfoBottomContainer,
	StyledInfoCarContainer,
	StyledNotActiveBackground,
	StyledSpeedInfoContainer,
	StyledSpeedText,
	StyledStatusIcon,
	StyledTurnSignal,
};
